module.exports = __webpack_public_path__ + "img/fibre-to-home.c54e8f57.jpg";